import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e1e3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-banner swiper-container" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "swiper-slide",
          key: index
        }, [
          _createElementVNode("img", {
            src: item.image,
            class: "banner-img",
            onClick: _withModifiers(($event: any) => (_ctx.navToUrl(item.url)), ["stop"])
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ]),
    _hoisted_4
  ]))
}